import { useQuery } from "@tanstack/react-query";
import { SanityClient } from "sanity";
import { SectionFilter, sectionCondition } from "./componentOptions";
import { MergedVersions, mergeVersions } from "./mergeVersions";

export type SanityComponentSearchQuery = {
  _id: string;
  _type: string;
  _createdAt: string;
  _updatedAt: string;
  _rev: string;
  sectionKey: string | null;
};

export type SanityComponentSearchResult =
  MergedVersions<SanityComponentSearchQuery>;

export const useSanityComponentSearch = (
  componentKey: string,
  filter: SectionFilter | undefined,
  client: SanityClient
) => {
  console.debug("do query", componentKey);
  return useQuery({
    queryKey: ["sanity-sections", componentKey, filter],
    enabled: !!componentKey && componentKey.length > 0,
    queryFn: async () => {
      const condition = sectionCondition(filter);
      const result = await client.fetch<SanityComponentSearchQuery[]>(
        `*[
            _type in [
              "page",
              "landingPage",
              "corporateIncentivePage",
              "exclusiveOfferPerPromo",
              "destination",
              "subDestination",
              "homepage",
              "sharedSection"
            ] &&
            !(_id in path("versions.**")) &&
            count(sections[${condition}]) > 0
           ] {
            _id,
            _type,
            _createdAt, _updatedAt, _rev,
            "sectionKey": sections[${condition}][0]._key
          }`,
        { componentKey, ...filter }
      );

      return mergeVersions(result);
    }
  });
};
